import { ApiError, Image } from "@blacknut/javascript-sdk/dist";

export enum PassActionTypes {
  PASS_GET_IMAGES_REQUEST = "PASS_GET_IMAGES_REQUEST",
  PASS_GET_IMAGES_SUCCESS = "PASS_GET_IMAGES_SUCCESS",
  PASS_GET_IMAGES_ERROR = "PASS_GET_IMAGES_ERROR",
}

export type PassAction =
  | {
      type: PassActionTypes.PASS_GET_IMAGES_REQUEST;
    }
  | {
      type: PassActionTypes.PASS_GET_IMAGES_SUCCESS;
      passId: string;
      images: Image[];
    }
  | {
      type: PassActionTypes.PASS_GET_IMAGES_ERROR;
      error?: ApiError;
    };
